import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup,
  CustomInput,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import CustomSelect from "../../../../helpers/ui/CustomSelect";

import apiResponse from "../../../../services/apiResponse";

import DetailBloc from "../Detail/Blocs/DetailBloc";
// import CreateBloc from '../Create/Blocs/CreateBloc'
import Shimmer from "react-shimmer-effect";

class IndexView extends Component {
  // updateBloc = new UpdateBloc();
  // createBloc = new CreateBloc();
  detailBloc = new DetailBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      employeeOptions: [],
      selectedEmployee: null,
      polaKerjaOptions: [],
      selectedPolaKerja: null,
      isLoadingOptEmployee: true,
      template: null,
      loadingDetail: false,
    };
  }

  reformatOptionsEmployee = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      //   newObj["label"] = data['employee_nip'] +' - '+ data[label];
      newObj["label"] = data[label];
      newObj["value"] = data[value];
      newObj["model"] = data;

      return newObj;
    });
  };

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
      newObj["model"] = data;

      return newObj;
    });
  };

  submitData = async () => {
    await this.updateBloc.fetchUpdate(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        uuid: this.state.dataForm.mapping_working_pattern_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingDetail: true,
          });

        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              dataForm: response,
              selectedTypeOption: response.retired_doctype_type_name,
              template: response.document_template
                ? response.document_template.documents_path
                : null,
              loadingDetail: false,
            });
          }
          break;
        case apiResponse.ERROR:
          this.setState({
            loadingDetail: false,
          });
          break;
        default:
          break;
      }
    });

    this.detailBloc.listStopChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            this.setState({
              listStopOptions: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    const queryParams = new URLSearchParams(this.props.location.search);
    this.detailBloc.fetchDetail({ uuid: queryParams.get("uuid") });

    this.detailBloc.fetchTypeStop();
  }

  componentWillUnmount() {
    this.detailBloc.detailChannel?.unsubscribe();
    this.detailBloc.listStopChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Detail Dokumen</CardTitle>
                  <CardSubtitle className="mb-3">
                    {/* Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi. */}
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_name"
                        className="col-md-2 col-form-label"
                      >
                        Nama Dokumen
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder=""
                          name="retired_doctype_name"
                          id="retired_doctype_name"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm?.retired_doctype_name}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_tooltip"
                        className="col-md-2 col-form-label"
                      >
                        Tooltip
                      </label>
                      <Col md="8">
                        <AvField
                          placeholder=""
                          name="retired_doctype_tooltip"
                          id="retired_doctype_tooltip"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm?.retired_doctype_tooltip}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_type_uuid"
                        className="col-md-2 col-form-label"
                      >
                        Jenis <span className="text-danger">*</span>
                      </label>
                      <Col md="6">
                        <Select
                          options={this.state.listStopOptions}
                          value={this.state.selectedTypeOption}
                          name={"retired_doctype_type_uuid"}
                          placeholder={"Pilih Jenis Pemberhentian"}
                          className="form-control"
                          // isSearchable={true}
                          // onChange={this.handleSelectChange}
                          isDisabled={true}
                          isMulti
                        />
                        <AvField
                          type="hidden"
                          name="retired_doctype_type_uuid"
                          value={this.state.selectedType}
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih Jenis Pemberhentian"
                          //
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_is_required"
                        className="col-md-2 col-form-label"
                      >
                        Mandatory
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder=""
                          name="retired_doctype_is_required"
                          id="retired_doctype_is_required"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.retired_doctype_is_required ===
                            1
                              ? "Ya"
                              : "Tidak"
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_status"
                        className="col-md-2 col-form-label"
                      >
                        Status
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder=""
                          name="retired_doctype_status"
                          id="retired_doctype_status"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.retired_doctype_status === 1
                              ? "Aktif"
                              : "Tidak Aktif"
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_sort"
                        className="col-md-2 col-form-label"
                      >
                        Nomor Urut
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder=""
                          name="retired_doctype_sort"
                          id="retired_doctype_sort"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm?.retired_doctype_sort}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        File Template
                      </Label>
                      <Col md="3">
                        {this.state.loadingDetail === true ? (
                          <>
                            <Shimmer>
                              <div style={{ width: "30%", height: 15 }}></div>
                            </Shimmer>
                          </>
                        ) : this.state.template ? (
                          <>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              className="btn btn-sm btn-primary"
                              href={this.state.template}
                            >
                              <i className="uil-file-download"></i> Download
                              File
                            </a>
                          </>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/master/pola_kerja_pegawai.html?" />
        ) : null}
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
